export const makeId = () => {
    return `${Date.now()}${Math.floor(Math.random() * 10000)}`;
};
